import { Component } from '@angular/core';
import { Error } from 'src/app/shared/components/error/error.model';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-tech-failed',
  templateUrl: './tech-failed.component.html',
  styleUrls: ['./tech-failed.component.scss']
})
export class TechFailedComponent {
  assetsUrl = environment.assetsUrl;
  public config: Error = {
    route: this.assetsUrl + '/images/cdt/icons/no-identity.svg',
    image: 'close-icon',
    width: '80px',
    title: 'No pudimos validar tu identidad',
    content: 'Debes comenzar nuevamente.',
    link: {
      url: '/',
      text: 'VOLVER'
    }
  };
}
